import { useTranslation } from "react-i18next";import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import {
  BuildingOffice2Icon,
  UserGroupIcon,
  CreditCardIcon,
  DocumentTextIcon } from
'@heroicons/react/24/outline';

const TOP_FEATURES = [
{
  icon: BuildingOffice2Icon,
  title: 'Building & Unit Management',
  description: 'Manage multiple buildings, floors, and apartments with complete property details and occupancy tracking.'
},
{
  icon: UserGroupIcon,
  title: 'Tenant Management',
  description: 'Complete tenant lifecycle management with automated billing, lease tracking, and digital onboarding.'
},
{
  icon: CreditCardIcon,
  title: 'Automated Payments',
  description: 'Stripe-powered payment collection with automatic reminders, installments, and multi-channel notifications.'
},
{
  icon: DocumentTextIcon,
  title: 'Digital Contracts',
  description: 'Electronic contract signing with customizable templates, audit trails, and secure PDF generation.'
}];


export default function Features() {const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  return (
    <section
      id="features"
      className={`py-24 lg:py-36 ${isDarkMode ? 'bg-zinc-950' : 'bg-white'} transition-colors duration-300`}>
      
            <div className="max-w-7xl mx-auto px-5 sm:px-8 md:px-16">
                {/* Header */}
                <div className="mb-20 text-center">
                    <p className="text-[11px] font-medium text-red-600 tracking-[3px] uppercase mb-8 flex items-center justify-center gap-3">
                        <span className="w-6 h-px bg-red-700" />
                        {t("complete_platform_1")}
                        <span className="w-6 h-px bg-red-700" />
                    </p>
                    <h2
            className={`${isDarkMode ? 'text-white' : 'text-black'} font-light leading-[1.05] mb-6`}
            style={{ fontFamily: "'Instrument Serif', Georgia, serif", fontSize: 'clamp(2.5rem,5vw,4.5rem)' }}>
                        {t("everything_you_need_to_manage")}
            <br />
                        <span className={`italic ${isDarkMode ? 'text-white/50' : 'text-zinc-950'}`}>{t("your_properties")}</span>
                    </h2>
                    <p className={`text-[15px] font-light leading-relaxed max-w-2xl mx-auto ${isDarkMode ? 'text-white/70' : 'text-black'}`}>
                        {t("a_comprehensive_property_management_syst")}
                    </p>
                </div>

                {/* Features List */}
                <div className="space-y-px">
                    {TOP_FEATURES.map((feature, index) =>
          <div
            key={index}
            className={`group relative overflow-hidden border-b ${
            isDarkMode ? 'border-white/[0.06]' : 'border-black/[0.08]'} transition-all duration-500 hover:bg-gradient-to-r ${

            isDarkMode ?
            'hover:from-red-950/10 hover:to-transparent' :
            'hover:from-red-50/50 hover:to-transparent'}`
            }>
            
                            <div className="flex items-start gap-8 py-8 px-6">
                                <div className="flex-shrink-0 mt-1">
                                    <feature.icon
                  className={`w-5 h-5 transition-colors duration-300 ${
                  isDarkMode ? 'text-white/45 group-hover:text-red-600' : 'text-black/20 group-hover:text-red-600'}`
                  }
                  strokeWidth={1.5} />
                
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h3 className={`text-xl font-light mb-2 transition-colors duration-300 ${
                isDarkMode ? 'text-white/85 group-hover:text-white' : 'text-black group-hover:text-red-700'}`
                } style={{ fontFamily: "'Instrument Serif', Georgia, serif" }}>
                                        {feature.title}
                                    </h3>
                                    <p className={`text-sm font-light leading-relaxed max-w-2xl ${isDarkMode ? 'text-white/55' : 'text-zinc-950'}`}>
                                        {feature.description}
                                    </p>
                                </div>
                                <div className={`flex-shrink-0 text-[10px] font-mono tracking-wider opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
              isDarkMode ? 'text-white/45' : 'text-black/50'}`
              }>
                                    {String(index + 1).padStart(2, '0')}
                                </div>
                            </div>
                        </div>
          )}
                </div>

                {/* View All Button */}
                <div className="mt-16 text-center">
                    <Link
            to="/features"
            className={`inline-flex items-center gap-3 px-8 py-4 rounded-full border transition-all duration-300 ${
            isDarkMode ?
            'border-white/10 hover:border-white/20 hover:bg-white/5' :
            'border-black/10 hover:border-black/20 hover:bg-black/5'}`
            }>
            
                        <span className={`text-sm font-light tracking-wide ${
            isDarkMode ? 'text-white/80' : 'text-black'}`
            }>{t("view_all_24_features")}</span>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={isDarkMode ? 'text-white/40' : 'text-black/40'}>
                            <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>
                </div>
            </div>
        </section>);

}